import React from 'react';
import { Button, notification, Table } from 'antd';
import { coupon } from '../../../Components/Columns/service';

import { TableContainer, TableWrapper } from './list.styled';
import { onDeleteCoupon } from '../../../Lib/Api/app';

export default class CouponList extends React.PureComponent {
    onRow = (row, index) => {
        return {
            onClick: () => {
                this.props.history.push({
                    pathname: `/coupon/info/${row._id}`,
                    state: {
                        id: row._id,
                    },
                });
            },
        };
    };

    onCouponDelete = async ({ _id }) => {
        console.log('_id: ', _id);

        const confirmed = window.confirm('해당 쿠폰을 삭제하시겠습니까?');
        if (!confirmed) return null;

        onDeleteCoupon({ couponId: _id }).then(resolve => {
            if (resolve && resolve.data === 'success') {
                notification.open({
                    message: '쿠폰을 삭제하였습니다.',
                    description: '쿠폰을 삭제하였습니다.',
                    type: 'success',
                });
                window.location.reload();
            }
        });
    };

    render() {
        // console.log(this.props.app.coupon);
        return (
            <>
                <TableWrapper>
                    <TableContainer>
                        <Table
                            rowKey='id'
                            dataSource={this.props.app.coupon.data}
                            columns={coupon({ onDelete: this.onCouponDelete })}
                            onRow={this.onRow}
                            pagination={{
                                pageSize: 10,
                            }}
                        />

                        <Button
                            type='primary'
                            onClick={() => {
                                this.props.history.push('/coupon/add');
                            }}
                        >
                            새 쿠폰 등록
                        </Button>
                    </TableContainer>
                </TableWrapper>
            </>
        );
    }
}
